import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Helmet } from "react-helmet-async";

import HomeHero from "../../components/HomeHero/HomeHero";
import LibraryItems from "../../components/LibraryItems/LibraryItems";
import LazySection from "../../components/LazySection/LazySection";
import MainAbout from "../../components/MainAbout/MainAbout";
import MainShare from "../../components/MainShare/MainShare";
import HowItWorks from "../../components/HowItWorks/HowItWorks";
import TutorialPreview from "../../components/TutorialPreview/TutorialPreview";
import NewsSection from "../../components/NewsSection/NewsSection";
import JoinCommunity from "../../components/JoinCommunity/JoinCommunity";
import { fetchPurchasedProducts } from "../../store/slices/profileProductSlice";
import isReactSnap from "../../utils/isReactSnap";
import pageStyles from "./index.module.css";

// The catalog is the homepage, and the informational sections of the old
// landing page follow it unchanged, in their original order. They keep their
// full-width treatment on purpose: condensed text-only teasers read as an
// unfinished page next to the rest of the site.
//
// The tail is deferred so its own network calls (NewsSection and
// TutorialPreview both fetch) do not compete with the product grid above.
const Home = () => {
  const dispatch = useDispatch();
  const { isAuthenticated } = useSelector((state) => state.user);

  useEffect(() => {
    if (isReactSnap) return;
    if (isAuthenticated) {
      dispatch(fetchPurchasedProducts({ page: 1, pageSize: 100 }));
    }
  }, [dispatch, isAuthenticated]);

  return (
    <>
      <Helmet>
        <title>Distortion Grids Database – Lens Distortion Grids Library</title>
        <meta
          name="description"
          content="Browse the full library of camera lens distortion grids, ST Maps and presets for VFX and matchmoving. Filter by camera, lens and format."
        />
        <meta
          property="og:title"
          content="Distortion Grids Database – Lens Distortion Grids Library"
        />
        <meta
          property="og:description"
          content="Browse the full library of camera lens distortion grids, ST Maps and presets for VFX and matchmoving. Filter by camera, lens and format."
        />
      </Helmet>

      <div className={pageStyles.heroWrap}>
        <HomeHero />
      </div>

      <LibraryItems />

      {/* Marks where browsing ends and reading begins. Kept outside LazySection
          so the seam is present from the first paint, not introduced later. */}
      <div className={pageStyles.tailDivider} aria-hidden="true" />

      {/* rootMargin is generous: these sections are full-screen and image-heavy,
          so they must be mounted well before they scroll into view or they pop
          in visibly. */}
      <LazySection minHeight={800} rootMargin="1200px">
        <MainAbout />
        <MainShare />
        <HowItWorks />
        <TutorialPreview />
        <NewsSection />
        <JoinCommunity />
      </LazySection>
    </>
  );
};

export default Home;
